import React from 'react';

const HelpPage = () => (
    <div>
        Help Page
    </div>
);

export default HelpPage;